// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"e6108d7a","760":"e6108d7a"}[chunkId] + ".chunk.css";
};